import { render, staticRenderFns } from "./forget-pass.vue?vue&type=template&id=4ed20d1a&scoped=true"
import script from "./forget-pass.vue?vue&type=script&lang=js"
export * from "./forget-pass.vue?vue&type=script&lang=js"
import style0 from "./forget-pass.vue?vue&type=style&index=0&id=4ed20d1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed20d1a",
  null
  
)

export default component.exports